import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { branch } from 'baobab-react/higher-order';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';

import Hero from './common/Hero';
import TrustedSection from './common/TrustedSection';
import TopProducts from './common/TopProducts';
import Commitment from './common/Commitment';
import TrustSection from './common/TrustSection';
import Certification from './common/Certification';
import TestResult from './common/TestResult';
import Testimonial from './common/Testimonial';
import FactSource from './common/FactSource';
import TotalProductCount from './common/TotalProductCount';
// import OptInPopup from "../components/OptInPopup";
import config from "../../config";
import VideoLeftTextRight from "../components/page/VideoLeftTextRight";
import ButtonLink from "../common/TrackedButtonLink";
import {buildEcomProductArrayForTopProducts, pushNewEcommerceEvent} from "../../utils/datalayer";
import InView from "../common/InView";

class Category extends Component {
	constructor(props) {
		super(props);
		this.handleTopProductsInview = this.handleTopProductsInview.bind(this);
	}
    
	handleTopProductsInview() {
		const {featuredProduct} = this.props;
		const items = buildEcomProductArrayForTopProducts(featuredProduct, 'Fire Safes and Fire Bag');
		pushNewEcommerceEvent('view_item_list', items);
	}
	render() {
		const pageTitle = 'Fireproof Safes & Fire Bag';
		const totalCount = this.props.category.productCount;
		let topProducts;
		// eslint-disable-next-line eqeqeq
		if (this.props.featuredProduct != null) {
			topProducts = (
				<InView onInView={this.handleTopProductsInview}>
					<TopProducts
						title={ `Best Selling FIREPROOF SAFES AND FIRE BAG` }
						subTitle="Powerful protection for the things that matter most."
						path="fire-safes"
						buttonCTA={ `View All` }
						topProduct={ this.props.featuredProduct }
					/>
				</InView>
			);
		}

		const videoTextData = {
			titleText: "SentrySafe Fireproof Safe vs. Other Brands",
			descriptionText: `<p><b>Watch the video</b> of our SentrySafe fireproof safe as it goes head-to-head with other brands in a one-hour fire test. Built to withstand temperatures up to 1700°, SentrySafe shows why it’s the only choice for protecting your valuables. <a href="/learn/fire-and-water-safes">Learn more about our next generation fireproof safes</a>.</p>`,
			videoUrl: 'https://fbinsecurity.widen.net/view/video/tsnmwwj5je/?u=tbvfmm'
		};

		return (
			<div className="category category-fire">
				<Helmet defer={false}>
					<title>{ pageTitle } &#124; SentrySafe</title>
					<meta name="description" content="Protect your valuables with a reliable fireproof safe or fire bag designed to withstand extreme conditions and keep your documents secure. Shop now." />
					<script async src={config.bazaarVoiceScriptUrl} />
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem path="/products" label="Products" />
					<BreadcrumbItem label={ pageTitle } />
				</Breadcrumb>

				<Hero
					imageSrc={ require('../../resources/img/hero/fire-safes.jpg') }
					imageAlt="Mother and daughter laughing"
					title={ `FIREPROOF SAFES AND FIRE BAG` }
					description="Never let a memory go unprotected."
				/>

				<TrustedSection
					content="SentrySafe introduced the first ever fire-resistant safe over 80 years ago. Today, SentrySafe products continue to provide proven fire protection for your memories, documents and valuables. Third-party verified, it&rsquo;s the type of fire protection you can depend on."
				/>

				{ topProducts }

				<Commitment
					header={ 'Our commitment to you' }
					imgSrc1={ require('../../resources/img/icons/impact-resistance-icon.png') }
					alt1={ 'Impact Resistance' }
					title1={ '&#36;50,000 Fire Protection Guarantee' }
					content1={ 'Get up to &#36;50,000 in insurance protection for your valuables.' }
					imgSrc2={ require('../../resources/img/icons/fire-guarantee-icon.png') }
					alt2={ 'Fire Protection Guarantee' }
					title2={ 'After-Fire Replacement Program' }
					content2={ 'Should your safe go through a fire, SentrySafe will send a replacement safe free of charge, so the things that matter most are protected for generations to come.'}
					imgSrc3={ require('../../resources/img/icons/after-fire-replacment-icon.png') }
					alt3={ 'After-Fire Replacement' }
					title3={ 'Warranty' }
					content3={ 'Your SentrySafe product was designed, built and thoroughly inspected at the factory for quality assurance, given normal use and care. SentrySafe warrants the quality and workmanship of your product according to the terms and conditions as stated in the owners&rsquo; manuals.' }
				/>

				<TrustSection
					title={ 'Trusted Fire Protection' }
					subTitle={ 'Throughout our lives, there are moments that change us forever. SentrySafe helps protect the memories and important documents that make these moments so special, providing peace of mind for a lifetime. SentrySafe products are built with you in mind.' }
				/>

				<section className="py-3">
					<VideoLeftTextRight data={videoTextData} />
				</section>

				<Certification
					header={ 'How We Test Our Products' }
					subHeader={ 'SentrySafe tests to rigorous standards to ensure that your important documents and valuables are kept safe during the unpredictable conditions of a fire.' }
					imgSrc1={ require('../../resources/img/icons/UL-logo.png') }
					alt1={ 'UL Fire Endurance' }
					title1="UL Fire Endurance"
					content1="UL Fire Endurance testing keeps interior temperatures below 350&deg;F (177&deg;C)"
					imgSrc2={ require('../../resources/img/icons/ETL-logo.png') }
					alt2={ 'ETL Verified Endurance' }
					title2={ 'ETL Verified Endurance' }
					content2={ 'All fire safes are ETL Verified to protect digital media and our EF safe models are ETL verified for 1/2-hour fire protection.' }
				/>

				{/*<TestResult*/}
				{/*	imgSrc1={ require('../../resources/img/icons/half-hour-icon.png') }*/}
				{/*	alt1={ 'Half Hour' } title1={ 'UL 1&#47;2 hour test' }*/}
				{/*	subTitle1={ 'withstands 1550&deg;F (843&deg;C) for 1&#47;2 hour' }*/}
				{/*	imgSrc2={ require('../../resources/img/icons/hour-icon.png') }*/}
				{/*	alt2={ 'Hour' }*/}
				{/*	title2={ 'UL 1-hour test' }*/}
				{/*	subTitle2={ 'withstands 1700&deg;F (927&deg;C) for 1 hour' }*/}
				{/*	imgSrc3={ require('../../resources/img/icons/two-hour-icon.png') }*/}
				{/*	alt3={ 'Two Hour' } title3={ 'UL 2-hour test' }*/}
				{/*	subTitle3={ 'withstands 1850&deg;F (1010&deg;C) for 2 hour' }*/}
				{/*/>*/}

				<Testimonial
					imgSrc1={ require('../../resources/img/callouts/testimonial-scott.jpg')}
					alt1={ 'Scott&rsquo;s Story' }
					imgSrc2={ require('../../resources/img/callouts/testimonial-quote.png') }
					alt2={ 'Quote' }
					quote={ 'After the fire, we found a square, concrete-looking blob. It took a couple of days, but we eventually got what was left of the safe open. We were so happy to find everything inside in tact&#33;' }
					submitted={ 'Scott F.' }
					readLink={ 'View all SentrySafe Stories' }
					link={ '/learn/customer-stories' }
				/>

				<FactSource
					title={ 'Did you know&#63;' }
					fact={ 'Every 24 seconds, a fire department in the United States is responding to a fire.' }
					source={ 'Source&#58; National Fire Protection Association' }
					imgeSrc={ require('../../resources/img/callouts/did-you-know-house-fire.png') }
					alt={ 'Burning House' }
				/>

				<TotalProductCount
					link="fire-safes"
					productTotal={ totalCount }
					name={ 'FIREPROOF PRODUCTS' }
				/>
				{/*<OptInPopup />*/}
			</div>
		);
	}
}

export default branch({
	category: ['category'],
	featuredProduct: ['category', 'featuredProduct', 'products']
}, Category);


// WEBPACK FOOTER //
// ./src/pages/category/FireCategory.js